import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthProvider';
import { supabase } from '../lib/supabase';

/**
 * Concelho slugs the current user can see in the briefing, via the
 * my_briefing_zones RPC (briefing_subscriptions rows on their email OR their
 * email domain, gated by the 'briefing' feature grant — see
 * sql/supabase/0003_briefing.sql). `zones` is null while loading, then a
 * (possibly empty) list. Not logged in or auth unconfigured → [].
 */
export function useBriefingZones() {
  const { user, loading: authLoading, configured } = useAuth();
  const [zones, setZones] = useState<string[] | null>(null);

  useEffect(() => {
    if (authLoading) return;
    if (!configured || !user) {
      setZones([]);
      return;
    }
    let cancelled = false;
    setZones(null);
    supabase.rpc('my_briefing_zones').then(({ data, error }) => {
      if (cancelled) return;
      if (error || !Array.isArray(data)) {
        setZones([]);
        return;
      }
      setZones(
        data
          .map((row: { concelho_slug?: string } | string) =>
            typeof row === 'string' ? row : (row.concelho_slug ?? ''),
          )
          .filter(Boolean),
      );
    });
    return () => {
      cancelled = true;
    };
  }, [user, configured, authLoading]);

  return { zones, loading: authLoading || zones === null };
}
